<template>
  <header class="header">
    <div class="header-top">
      <v-container style="height: 100%;">
        <v-row align="center" style="height: 100%;">
          <v-col>
            <v-row>
              <v-col cols="12" sm="7">
                <h3>
                  The U.S. Government's Prosper Africa Initiative helps U.S. businesses and investors pursue promising trade and investment opportunities in Africa
                </h3>
              </v-col>
              <v-col v-if="!loggedIn" cols="12" sm="5" class="login-button">
                <v-row align="center">
                  <v-col>
                    <v-btn
                      x-large
                      style="height: 80px;"
                      color="#f0b323"
                      @click="goToSubmission"
                    >
                      Register your interest
                    </v-btn>
                  </v-col>
                  <v-col>
                    <span class="mr-2">Already registered?</span>
                    <br />
                    <a @click="login">SIGN IN →</a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="header-bottom">
      <v-container>
        <v-row>
          <v-col cols="12" md="5">
            <p v-if="loggedIn">
              This virtual deal room is updated regularly with curated trade and investment opportunities between the U.S. and Africa. Please check back frequently to review the newest deals.
            </p>
            <p v-if="!loggedIn">
              This virtual deal room allows enterprises, investors, and counterparties to engage with curated trade and investment opportunities between the U.S. and Africa.
            </p>
          </v-col>
          <v-col cols="12" md="5">
            <p>You can also find information about <a href="https://www.prosperafrica.gov/services/" target="_blank">U.S. Government services and resources</a> that can support successful private sector transactions.</p>
          </v-col>
          <v-col class="shrink d-flex" cols="12" md="2">
            <a href="https://www.prosperafrica.gov/about/" class="learn-more" target="_blank">
              <span class="mr-2">Learn more about</span>
              <span>Prosper Africa →</span>
            </a>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-if="!loggedIn" class="announce-wrap">
      <v-container>
        <v-row>
          <v-col cols="12" style="padding-left: 0px;">
            <announce-banner />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </header>
</template>

<script>
import AnnounceBanner from '@/components/common/announce-banner'

export default {
  name: 'app-header',
  components: {
    AnnounceBanner
  },
  props: {
    loggedIn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    login () {
      this.$store.dispatch('modals/showModal', 'login')
    },
    goToSubmission () {
      this.$vuetify.goTo('#submission-form')
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'click-register-interest',
        eventLabel: 'Register interest header click'
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";
.header {
  .header-top {
    margin-top: 100px;
  }
  .header-bottom {
    background: #f0f0f0;
    backdrop-filter: blur(20px);
    opacity: 0.98;
    font-size: 18px;
    line-height: 150%;
    padding-top: 30px;
    padding-bottom: 40px;
    a {
      color: #002f6c;
    }
  }
}
.announce-wrap {
  margin-bottom: 92px;
  margin-top: 48px;
}
h3 {
  font-family: $header-font;
  font-weight: 500;
  line-height: 140%;
  font-size: 24px;
  margin-bottom: 25px;
}
.learn-more {
  display: flex;
  flex-direction: column;
  font-weight: 600;
  font-size: 16px;
  line-height: 130%;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-decoration: none;
  color: #002f6c;
  span {
    white-space: nowrap;
  }
}
.login-button {
  a {
    color: #002f6c;
  }
}
</style>
